import React from 'react';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const AdditionalInfoStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  return (
    <textarea
      value={answer || ''}
      onChange={(e) => onAnswer(e.target.value)}
      placeholder="E.g. I'm returning to training after a long-standing calf injury; I have a holiday in 6 weeks..."
      style={{
        width: '100%',
        minHeight: 140,
        padding: '20px 16px',
        border: '1px solid rgba(250,253,251,0.16)',
        borderRadius: 16,
        fontSize: 16,
        fontWeight: 400,
        boxSizing: 'border-box' as const,
        background: 'rgba(250,253,251,0.08)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        color: '#FAFDFB',
        fontFamily: "'Figtree', sans-serif",
        outline: 'none',
        resize: 'vertical' as const,
        lineHeight: '140%',
      }}
    />
  );
};

export default AdditionalInfoStep;
